export default __webpack_public_path__ + "static/media/weatherShiftLogo.92bb3eca.png";